import React from "react";

import Background from "../assets/serv.png";

function Services() {
  return (
    <div
      className="h-96 bg-cover md:bg-cover bg-no-repeat bg-center flex items-center justify-center"
      style={{ backgroundImage: `url(${Background})` }}
    >
      <div className="text-center">
        <h1 className="text-4xl md:text-7xl md:mb-20 font-bold text-yellow-400 drop-shadow-lg">
          Our Services
        </h1>
      </div>
    </div>
  );
}

export default Services;
